var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7042 2.25C13.71 2.25 14.6775 2.6475 15.3892 3.36075C16.1017 4.0725 16.5 5.0325 16.5 6.0375V11.9625C16.5 14.055 14.7975 15.75 12.7042 15.75H5.295C3.20175 15.75 1.5 14.055 1.5 11.9625V6.0375C1.5 3.945 3.19425 2.25 5.295 2.25H12.7042ZM13.8975 7.155L13.9575 7.095C14.1368 6.8775 14.1368 6.5625 13.9493 6.345C13.845 6.23325 13.7018 6.165 13.5525 6.15C13.395 6.14175 13.245 6.195 13.1318 6.3L9.75 9C9.315 9.36075 8.69175 9.36075 8.25 9L4.875 6.3C4.64175 6.1275 4.31925 6.15 4.125 6.3525C3.9225 6.555 3.9 6.8775 4.07175 7.1025L4.17 7.2L7.5825 9.8625C8.0025 10.1925 8.51175 10.3725 9.045 10.3725C9.57675 10.3725 10.095 10.1925 10.5142 9.8625L13.8975 7.155Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.2fb96112ea516a6c0ee92559dee61434.svg";
export { ForwardRef as ReactComponent };